import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { DeclaracionModelo303DtoProps } from "api/DTOs/DeclaracionModelo303Dto"
import { Checkbox } from "primereact/checkbox"
import { InputText } from "primereact/inputtext"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  calculateCasilla64SumaResultados,
  calculateCasilla66AtribuibleAdministracion,
  calculateCasilla69Autoliquidacion,
  calculateCasilla71Resultado,
  calculateCasilla87Compensar,
} from "../DeclaracionModelo303/constants"

const ResultadoModelo303 = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<DeclaracionModelo303DtoProps>
  watch: UseFormWatch<DeclaracionModelo303DtoProps>
}) => {
  const { t } = useTranslation()

  const values = watch()
  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col'>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-t tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box1")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla76}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='76'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla76", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box2")}
        </span>
        <InputCurrencyGroup
          value={calculateCasilla64SumaResultados(values)}
          placeholder='0,00'
          disabled
          className='tw-h-full'
          numberGroup='64'
          suffix='€'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-3'>
          {t("taxSummary.declaracion.resultadoFinal.box3")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla65}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='65'
          suffix='%'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla65", value || 0)
          }
        />
        <InputCurrencyGroup
          value={calculateCasilla66AtribuibleAdministracion(values)}
          placeholder='0,00'
          disabled
          className='tw-h-full'
          numberGroup='66'
          suffix='€'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box4")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla77}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='77'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla77", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box5")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla110}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='110'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla110", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box6")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla78}
          placeholder='0,00'
          className='tw-h-full'
          disabled
          numberGroup='78'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla78", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box7")}
        </span>
        <InputCurrencyGroup
          value={calculateCasilla87Compensar(values)}
          placeholder='0,00'
          className='tw-h-full'
          disabled
          numberGroup='87'
          suffix='€'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-min-h-12 tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-flex-1 tw-text-start'>
          {t("taxSummary.declaracion.resultadoFinal.box8")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box9")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla68}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='68'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla68", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box10")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla108}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='108'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla108", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box11")}
        </span>
        <InputCurrencyGroup
          value={calculateCasilla69Autoliquidacion(values)}
          placeholder='0,00'
          disabled
          className='tw-h-full'
          numberGroup='69'
          suffix='€'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box12")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla70}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='70'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla70", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box13")}
        </span>
        <InputCurrencyGroup
          value={values.dp30303?.casilla109}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='109'
          suffix='€'
          onChange={(value: number | undefined) =>
            setValue("dp30303.casilla109", value || 0)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box14")}
        </span>
        <InputCurrencyGroup
          value={calculateCasilla71Resultado(values)}
          disabled
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='71'
          suffix='€'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-font-medium tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box35")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.resultadoFinal.box35")}
        </span>
        <Checkbox
          checked={values.dp30303?.sinActividad}
          onChange={() =>
            setValue("dp30303.sinActividad", !values.dp30303?.sinActividad)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12 tw-text-sm'>
        <span className='tw-font-medium tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box36")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12 tw-text-sm'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.resultadoFinal.box37")}
        </span>
        <span className='tw-flex tw-flex-row tw-gap-3'>
          <span>{t("taxSummary.declaracion.resultadoFinal.box38")}</span>
          <Checkbox
            checked={values.dp30303?.autoliquidacionRectificativa}
            onChange={() =>
              setValue(
                "dp30303.autoliquidacionRectificativa",
                !values.dp30303?.autoliquidacionRectificativa
              )
            }
          />
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12 tw-text-sm'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.resultadoFinal.box39")}
        </span>
        <span className='tw-flex tw-flex-row tw-gap-3 tw-items-center'>
          <span>{t("taxSummary.declaracion.resultadoFinal.box40")}</span>
          <InputText
            value={values.dp30303?.numeroJustificante ?? ""}
            className='tw-text-sm'
            onChange={(value) =>
              setValue("dp30303.numeroJustificante", value.target.value)
            }
          />
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12 tw-text-sm'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.resultadoFinal.box41")}
        </span>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-flex tw-flex-row tw-gap-3 tw-items-end'>
            <span>{t("taxSummary.declaracion.resultadoFinal.box42")}</span>
            <Checkbox
              checked={values.dp30303?.motivoRectificacionRectificaciones}
              onChange={() =>
                setValue(
                  "dp30303.motivoRectificacionRectificaciones",
                  !values.dp30303?.motivoRectificacionRectificaciones
                )
              }
            />
          </span>
          <span className='tw-flex tw-flex-row tw-gap-3 tw-justify-end'>
            <span>{t("taxSummary.declaracion.resultadoFinal.box43")}</span>
            <Checkbox
              checked={values.dp30303?.motivoRectificacionDiscrepancia}
              onChange={() =>
                setValue(
                  "dp30303.motivoRectificacionDiscrepancia",
                  !values.dp30303?.motivoRectificacionDiscrepancia
                )
              }
            />
          </span>
        </div>
      </div>
      {/* <div className='tw-w-full tw-h-fit tw-min-h-12 tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-base tw-font-medium'>
          {t("taxSummary.declaracion.resultadoFinal.box15")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-min-h-12 tw-grid tw-grid-cols-7 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-6'>
          {t("taxSummary.declaracion.resultadoFinal.box16")}
        </span>
        <div className='tw-flex tw-justify-end tw-items-center tw-gap-3'>
          <span className='tw-text-sm tw-text-right'>
            {t("taxSummary.declaracion.resultadoFinal.box16checkbox")}
          </span>
          <Checkbox checked={false} />
        </div>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box17")}
        </span>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-font-medium tw-text-left'>
            {t("taxSummary.declaracion.resultadoFinal.box17label")}
          </span>
          <InputText value='' />
        </div>
      </div>
      <div className='tw-w-full tw-h-fit tw-min-h-12 tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-base tw-font-medium'>
          {t("taxSummary.declaracion.resultadoFinal.box18")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-4 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <div className='tw-flex tw-flex-col tw-w-full'>
          <span className='tw-text-xs tw-font-medium tw-text-left'>
            {t("taxSummary.declaracion.resultadoFinal.box18cityOne")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30303?.casilla89}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='89'
            onChange={(value: number | undefined) =>
              setValue("dp30303.casilla89", value || 0)
            }
          />
        </div>
        <div className='tw-flex tw-flex-col tw-w-full'>
          <span className='tw-text-xs tw-font-medium tw-text-left'>
            {t("taxSummary.declaracion.resultadoFinal.box18cityTwo")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={values.dp30303?.casilla90}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='90'
            onChange={(value: number | undefined) =>
              setValue("dp30303.casilla90", value || 0)
            }
          />
        </div>
        <div className='tw-flex tw-flex-col tw-w-full'>
          <span className='tw-text-xs tw-font-medium tw-text-left'>
            {t("taxSummary.declaracion.resultadoFinal.box18cityThree")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={0}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='91'
          />
        </div>
        <div className='tw-flex tw-flex-col tw-w-full'>
          <span className='tw-text-xs tw-font-medium tw-text-left'>
            {t("taxSummary.declaracion.resultadoFinal.box18cityFour")}
          </span>
          <InputCurrencyGroup
            suffix='€'
            value={0}
            placeholder='0,00'
            className='tw-h-full'
            numberGroup='92'
          />
        </div>
      </div>
      <div className='tw-w-full tw-h-fit tw-min-h-12 tw-grid tw-grid-cols-7 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-6'>
          {t("taxSummary.declaracion.resultadoFinal.box19")}
        </span>
        <div className='tw-flex tw-justify-end tw-items-center'>
          <Checkbox checked={false} />
        </div>
      </div>
      <div className='tw-w-full tw-h-fit tw-min-h-12 tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-base tw-font-medium'>
          {t("taxSummary.declaracion.resultadoFinal.box20")}
        </span>
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box21")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='80'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box22")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='81'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box23")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='93'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box24")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='94'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box25")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='83'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box26")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='84'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box27")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='85'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box28")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='86'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box29")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='95'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box30")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='96'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box31")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='97'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box32")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='98'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4'>
          {t("taxSummary.declaracion.resultadoFinal.box33")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='99'
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 '>
        <span className='tw-text-sm tw-text-left tw-flex tw-justify-start tw-items-center tw-col-span-4 tw-font-medium'>
          {t("taxSummary.declaracion.resultadoFinal.box34")}
        </span>
        <InputCurrencyGroup
          suffix='€'
          value={0}
          placeholder='0,00'
          className='tw-h-full'
          numberGroup='88'
        />
      </div> */}

      <span className='tw-text-xs tw-text-right tw-w-full tw-py-1 tw-px-6'>
        {t("taxSummary.declaracion.infoMsg")}
      </span>
    </div>
  )
}

export default ResultadoModelo303
